<template>
  <div class="bg-white">
    <div class="container top-0 position-sticky z-index-sticky">
      <div class="row">
        <div class="col-12">
          <navbar
            isBlur="blur my-3 py-2 mt-4 start-0 end-0 mx-4 shadow blur border-radius-lg"
            btnBackground="bg-cap-red"
            v-bind:darkMode="true"
          />
        </div>
      </div>
    </div>

    <main class="mt-0 main-content">
      <section>
        <div class="page-header min-vh-100">
          <div class="container">
            <div class="row">
              <!-- Left Image Column -->
              <div
                class="col-6 d-lg-flex d-none h-100 my-auto pe-0 ps-0 position-absolute top-0 start-0 text-center justify-content-center flex-column"
              >
                <div
                  class="position-relative h-100 m-3 px-7 border-radius-lg d-flex flex-column justify-content-center"
                  :style="{
                    backgroundImage: 'url(' + require('@/assets/img/capp.png') + ')',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center'
                  }"
                ></div>
              </div>

              <!-- Form -->
              <div
                class="col-xl-4 col-lg-5 col-md-7 d-flex flex-column ms-auto me-auto ms-lg-auto me-lg-5"
              >
                <div class="card card-plain">
                  <!-- 🔴 Title -->
                  <div class="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
                    <div class="bg-cap-red shadow-danger border-radius-lg py-3 pe-1">
                      <h4 class="text-white font-weight-bolder text-center mt-2 mb-0">Sign Up</h4>
                    </div>
                  </div>

                  <div class="card-body mt-3">
                    <form role="form">
                      <div class="mb-3">
                        <material-input
                          id="name"
                          type="text"
                          label="Name"
                          name="name"
                          size="lg"
                        />
                      </div>
                      <div class="mb-3">
                        <material-input
                          id="email"
                          type="email"
                          label="Email"
                          name="email"
                          size="lg"
                        />
                      </div>
                      <div class="mb-3">
                        <material-input
                          id="password"
                          type="password"
                          label="Password"
                          name="password"
                          size="lg"
                        />
                      </div>

                      <material-checkbox id="terms" class="font-weight-light" checked>
                        I agree to the
                        <a href="#" class="text-cap-red font-weight-bolder">
                          Terms and Conditions
                        </a>
                      </material-checkbox>

                      <div class="text-center">
                        <material-button
                          class="mt-4"
                          variant="gradient"
                          color="cap-red"
                          fullWidth
                          size="lg"
                        >
                          Sign Up
                        </material-button>
                      </div>
                    </form>
                  </div>

                  <div class="px-1 pt-0 text-center card-footer px-lg-2">
                    <p class="mx-auto mb-4 text-sm">
                      Already have an account?
                      <router-link
                        :to="{ name: 'SignIn' }"
                        class="text-cap-red text-gradient font-weight-bold"
                      >
                        Sign In
                      </router-link>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import Navbar from "@/examples/PageLayout/Navbar.vue";
import MaterialInput from "@/components/MaterialInput.vue";
import MaterialCheckbox from "@/components/MaterialCheckbox.vue";
import MaterialButton from "@/components/MaterialButton.vue";
const body = document.getElementsByTagName("body")[0];
import { mapMutations } from "vuex";

export default {
  name: "sign-up",
  components: {
    Navbar,
    MaterialInput,
    MaterialCheckbox,
    MaterialButton,
  },
  beforeMount() {
    this.toggleEveryDisplay();
    this.toggleHideConfig();
    body.classList.remove("bg-gray-100");
  },
  beforeUnmount() {
    this.toggleEveryDisplay();
    this.toggleHideConfig();
    body.classList.add("bg-gray-100");
  },
  methods: {
    ...mapMutations(["toggleEveryDisplay", "toggleHideConfig"]),
  },
};
</script>

<style scoped>
/* 🔴 Couleur CAP personnalisée */
.bg-cap-red {
  background: linear-gradient(195deg,rgb(121, 34, 113),rgb(115, 34, 111));
}

.text-cap-red {
  color:rgb(73, 4, 61) !important;
}
</style>
